import { Box, Center, Flex, Image } from "@chakra-ui/react";
import React from "react";
import cat from "../assets/images/cat.svg";
import qrCode from "../assets/images/la_qrcode.svg";
import telegramPlane from "../assets/images/la_telegram-plane.svg";
import grabBox from "../assets/images/big_cat.svg";

import CustomText from "./CustomText";

const QrSection = () => {
  return (
    <section id="whitepaper">
      <Center
        flexDirection={"column"}
        mt="-50px"
        pos={"relative"}
        pb={"120px"}
        display={{ base: "flex", lg: "none" }}
      >
        <Image src={grabBox} alt="big-cat" w={"40%"} mr={"-160px"} />
        <Image src={cat} alt="big-cat" w={"60%"} ml={"-30px"} mt={"-50px"} />
        <Image src={qrCode} alt="big-cat" w={"60%"} />
        <Flex
          gap={"5px"}
          align={"flex-start"}
          justify={"center"}
          textAlign={"center"}
          px="20px"
          pos="relative"
        >
          <Image
            src={telegramPlane}
            alt="telegram"
            w={"30px"}
            pos="absolute"
            top="0"
            left="0"
            ml="20px"
          />
          <CustomText
            text={
              <>
                <span style={{ marginLeft: "22px" }}></span>
                <span>
                  Snag the fcking airdrop, keep your cool as the energy
                  skyrockets, and crushit on that kickass Telegram game. You’re
                  late? Who the fck cares, just get in!
                </span>
              </>
            }
            size={"22px"}
            height="26.97px"
            color="#191919"
            align="center"
          />
        </Flex>
      </Center>
      <Flex
        py={"150px"}
        mx="auto"
        maxW={"1250px"}
        justify={"center"}
        align={"center"}
        position={"relative"}
        display={{ base: "none", lg: "flex" }}
        //   gap={"10%"}
      >
        <Box position={"absolute"} top={-20} ml={"80px"}>
          <Image src={grabBox} alt="grabBox" />
        </Box>
        <Box w={"50%"}>
          <Image src={cat} alt="cat" />
        </Box>
        <Box maxW="680px" w="100%">
          <Center>
            <Image src={qrCode} alt="qrcode" />
          </Center>
          <Flex gap={"5px"} align={"flex-start"} pos="relative">
            <Image
              src={telegramPlane}
              alt="telegram"
              pos="absolute"
              top="0"
              mt="-40px"
              ml="20px"
            />
            <CustomText
              text={
                <>
                  <span style={{ marginLeft: "80px" }}></span>
                  <span>
                    Snag the fcking airdrop, keep your cool as the energy
                    skyrockets, and crushit on that kickass Telegram game.
                    You’re late? Who the fck cares, just get in!
                  </span>
                </>
              }
              size="36px"
              height="40.97px"
              color="#191919"
              align="center"
            />
          </Flex>
        </Box>
      </Flex>
    </section>
  );
};

export default QrSection;
